export enum STORAGE_ACTION {
  UTM_SOURCE = 'UTM_SOURCE',
  UTM_MEDIUM = 'UTM_MEDIUM',
  UTM_CAMPAIGN = 'UTM_CAMPAIGN'
}
